<template>
  <div>
    <div style="display: flex; align-items: center;margin-bottom: 30px;">
      <el-input type="text" v-model="verificationCode" placeholder="请输入广告组名称搜索"
        style="width: 250px; height: 40px; margin-right: 10px;" />

      <el-button type="primary" @click="query">查询</el-button>
      <el-button type="primary" @click="gettheout">新增</el-button>
    </div>
    <el-card class="data-card">
      <el-table :data="responseResultslist" row-key="id"
        :tree-props="{ children: 'children' }" v-loading="loading" border style="width: 100%">

        <el-table-column prop="khname" label="代理商名称"></el-table-column>
        <el-table-column prop="qttuname" label="广告主账号"></el-table-column>
        <el-table-column label="登录状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row)" size="small">{{ statusText(row) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="checkTime" label="最后巡检" width="170">
          <template slot-scope="{ row }">{{ formatStatusTime(row.checkTime) }}</template>
        </el-table-column>
        <el-table-column prop="lastLoginTime" label="最后登录" width="170">
          <template slot-scope="{ row }">{{ formatStatusTime(row.lastLoginTime) }}</template>
        </el-table-column>
        <el-table-column prop="qttstatus" label="编辑" width="340">
          <template #default="{ row }">
            <div class="action-btns" style=" display: flex;
  gap: 4px;              /* 按钮间距 */
  flex-wrap: nowrap;     /* 不换行 */
  white-space: nowrap;  ">
              <el-button type="primary" @click="editchang(row)">编辑</el-button>
              <el-button type="primary" @click="showRechargeDialog(row)">充值</el-button>
              <el-button type="primary" @click="fzChange(row)">复制</el-button>
              <el-button type="danger" @click="delchang(row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog title="复制账户信息" :visible.sync="dialogVisible" width="60%">
      <div style="margin: 10px 30px; display: flex">
        <el-button type="success" @click="addRow">添加数据</el-button>
        <el-button type="info" @click="downloadTemplate">下载模板</el-button>
        <el-upload style="margin: 0px 20px;" :before-upload="handleExcelImport" :show-file-list="false"
          accept=".xlsx, .xls">
          <el-button type="warning">Excel导入</el-button>
        </el-upload>

      </div>

      <el-table :data="zzformData" border style="max-height: 550px; overflow-y: auto;">
        <el-table-column label="被复制账户ID">
          <template slot-scope="scope">
            <el-input v-model="scope.row.accountId" placeholder="请输入账户ID"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="账号名称">
          <template slot-scope="scope">
            <el-input v-model="scope.row.accountName" placeholder="请输入账号名称"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="密码">
          <template slot-scope="scope">
            <el-input v-model="scope.row.password" placeholder="请输入密码" show-password></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="danger" icon="el-icon-delete" @click="deleteRow(scope.$index)" circle></el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="数据操作" :visible.sync="outerVisible" :close-on-click-modal="false">
      <el-form ref="formdata" :model="formdata" :rules="rules" label-width="100px">
        <el-form-item label="代理商名称" prop="khname">
          <el-input v-model="formdata.khname"></el-input>
        </el-form-item>
        <el-form-item label="账户名" prop="qttuname">
          <el-input v-model="formdata.qttuname"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="qttpsd">
          <el-input type="password" v-model="formdata.qttpsd"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="wuxiao1">取 消</el-button>
        <el-button type="primary" @click="innerVisible">确定编辑</el-button>
      </div>
    </el-dialog>
    <el-dialog title="数据操作" :visible.sync="outerVisible2" :close-on-click-modal="false">
      <el-form ref="formdata2" :model="formdata2" :rules="rules2" label-width="100px">
        <el-form-item label="代理商名称" prop="khname">
          <el-input v-model="formdata2.khname"></el-input>
        </el-form-item>
        <el-form-item label="账户名" prop="qttuname">
          <el-input v-model="formdata2.qttuname"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="qttpsd">
          <el-input type="password" v-model="formdata2.qttpsd"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="wuxiao2">取 消</el-button>
        <el-button type="primary" @click="innerVisible2">确定新增</el-button>
      </div>
    </el-dialog>
    <el-dialog title="充值管理" :visible.sync="rechargeDialogVisible" width="880px" custom-class="recharge-dialog"
      :close-on-click-modal="false">
      <div class="dialog-content">
        <div class="m-header">
          <el-button type="default" :class="{ 'active': activeTab === 'separate' }" @click="activeTab = 'separate'">
            <i class="el-icon-edit"></i>
            <span>分别充值</span>
          </el-button>
          <el-button type="default" :class="{ 'active': activeTab === 'unified' }" @click="activeTab = 'unified'">
            <i class="el-icon-edit"></i>
            <span>统一充值</span>
          </el-button>
          <div>
            <h2>账户余额：{{ Rechargenumber }}</h2>
          </div>
        </div>

        <!-- 分别充值 -->
        <div v-show="activeTab === 'separate'" class="separate-recharge">
          <el-table :data="Recharge" style="width: 100%" height="400px" border>
            <el-table-column prop="id" label="账户ID" width="100"></el-table-column>
            <el-table-column prop="username" label="广告主用户名" width="130"></el-table-column>
            <el-table-column prop="balance" label="当前余额(元)" width="120">
              <template slot-scope="scope">
                {{ formatMoney(scope.row.balance) }}
              </template>
            </el-table-column>
            <el-table-column label="充值金额(元)" width="360">
              <template slot-scope="scope">
                <el-form class="el-form--inline">
                  <el-form-item label="充值金额：">
                    <el-input-number v-model="scope.row.rechargeAmount" placeholder="请输入"
                      controls-position="right"></el-input-number>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 统一充值 -->
        <div v-show="activeTab === 'unified'" class="unified-recharge">
          <div class="unified-container">
            <!-- 左侧表格 -->
            <el-table :data="Recharge" style="flex: 1" height="400px" border>
              <el-table-column prop="id" label="账户ID"></el-table-column>
              <el-table-column prop="username" label="广告主用户名"></el-table-column>
              <el-table-column prop="balance" label="当前余额(元)">
                <template slot-scope="scope">
                  {{ formatMoney(scope.row.balance) }}
                </template>
              </el-table-column>
            </el-table>

            <!-- 右侧表单 -->
            <div class="batch-form">
              <!-- 模拟表头 -->
              <div class="batch-header">统一充值</div>
              <div class="batch-body">
                <el-form class="el-form--inline">
                  <el-form-item label="充值金额(元)：">
                    <el-input-number v-model="unifiedRechargeAmount" placeholder="请输入"
                      controls-position="right"></el-input-number>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleRecharge" :loading="recharging">
          提交充值
        </el-button>
        <el-button @click="rechargeDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import XLSX from 'xlsx';
export default {

  data() {
    return {
      Recharge: [],
      rechargeDialogVisible: false,
      activeTab: 'separate',
      recharging: false,
      unifiedRechargeAmount: 100,
      outerVisible2: false,
      formdata: {
        khname: "",
        qttuname: "",
        qttpsd: "",
        id: "",
        qttcookie: ""
      },
      dialogVisible: false,
      zzformData: [
        { accountId: '', accountName: '', password: '' }
      ],
      formdata2: {
        khname: "",
        qttuname: "",
        qttpsd: "",
        id: "",
        qttcookie: ""
      },
      outerVisible: false,
      value1: [],
      verificationCode: "",
      selectedDate: "",
      selectedOption1: '',        // 下拉框1选中值
      selectedOption2: '',        // 下拉框2选中值
      selectedOptions: [],
      selectfzzh: {},
      // 全选特殊对象（避免与正常数据冲突）
      selectAllItem: { isSelectAll: true },
      selectAllLabel: "不限",
      clientList: [],
      responseResults: [],// 新增用于存储响应结果,,
      responseResultslist: [],
      responseResultslistchildren: [],
      // 下拉框选项数据
      loading: false,
      summaryData: {
        id: 1,
      },
      statusnum: 0,
      rules: {
        khname: [
          { required: true, message: '请输入代理商名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        qttuname: [
          { required: true, message: '请输入账户名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        qttpsd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ]
      },
      rules2: {
        khname: [
          { required: true, message: '请输入代理商名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        qttuname: [
          { required: true, message: '请输入账户名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        qttpsd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ]
      },
      userId: '',
      Rechargenumber: 0
    };
  },
  created() {
    // 从路由参数获取用户ID
    this.userId = this.$route.query.userId

    if (!this.userId) {
      // 使用Element UI的消息提示
      this.$message.warning('您得先登录')

      // 设置延迟跳转让用户看到提示
      setTimeout(() => {
        // 重定向到登录页面（外部链接）
        window.location.href = 'https://control.zjwec.cn/page/end/login.html'
      }, 1500)  // 1.5秒后跳转

      // 终止后续执行
    }


    // this.showLibrarySelector();
    this.getUlist()
  },

  methods: {
    showRechargeDialog(row) {
      this.Rechargenumber = 0
      this.activeTab = 'separate'
      this.Recharge = []
      this.unifiedRechargeAmount=100
      this.$axios.get('https://control.zjwec.cn/api/qtt/customers', {
        params: {
          cookie: row.qttcookie
        }
      }).then(response => {
        console.log(response.data);
        this.Recharge = response.data.map(item => ({
          ...item,
          cookie: row.qttcookie,
          // rechargeAmount: 0 // 默认充值金额设为 0
        }));
        console.log(this.Recharge);
      }).catch(error => {
        this.$message.error('获取失败');
      });
      this.$axios.get('https://control.zjwec.cn/api/qtt/controlUser', {
        params: {
          cookie: row.qttcookie
        }
      }).then(response => {
        this.Rechargenumber = response.data.balance / 100;

      }).catch(error => {
        this.$message.error('获取失败');
      });


      this.rechargeDialogVisible = true;
    },

    formatMoney(value) {
      return (value / 100).toFixed(2)
    },

    async handleRecharge() {
      this.recharging = true

      try {
        this.recharging = true; // 显示加载状态

        if (this.activeTab === 'separate') {
          const validRecharges = this.Recharge.filter(item => item.rechargeAmount != null);
          let warningMessages = [];
          for (const item of validRecharges) {
            let originalAmount = item.rechargeAmount;
            let amountToUse = Math.abs(originalAmount);
            let message = '';

            if (originalAmount < 0) {
              if (amountToUse <= (item.balance / 100)) {
                message = `${item.username} 提取 ${amountToUse} 元，操作中...`;
                amountToUse = -amountToUse;
              } else {
                warningMessages.push(`${item.username} 提取失败：提取金额大于账户余额`);
                continue;
              }
            } else if (originalAmount > 0) {
              if (amountToUse <= this.Rechargenumber) {
                message = `${item.username} 充值 ${amountToUse} 元，操作中...`;
                this.Rechargenumber -= amountToUse;
              } else {
                warningMessages.push(`${item.username} 充值失败：可用充值余额不足`);
                continue;
              }
            } else {
              warningMessages.push(`${item.username} 金额为0，跳过操作`);
              continue;
            }

            console.log(message);
            try {
              const res = await this.$axios.post('https://control.zjwec.cn/api/qtt/charge', {
                cookie: item.cookie,
                money: amountToUse * 100,
                user: item.id
              });

              if (res.data.data.errorType == 'errorMessage') {
                this.$message.error(`${item.username} 操作失败: ${res.data.data.message}`);
              } else {
                this.$message.success(`${item.username} 操作成功！`);
              }
            } catch (error) {
              this.$message.error(`${item.username} 操作失败: ${error.message}`);
            }
          }
          if (warningMessages.length > 0) {

            warningMessages.forEach((item, index) => {
              setTimeout(() => {
                this.$message.warning(item);
              }, index * 1000);
            });

          }

        } else {
          console.log(this.unifiedRechargeAmount);
          if (!this.unifiedRechargeAmount && this.unifiedRechargeAmount != 0) {
            this.$message.warning('请输入有效的统一充值金额');
            return;
          }
          if(this.unifiedRechargeAmount>0&&this.unifiedRechargeAmount>this.Rechargenumber){
            this.$message.warning('充值失败，金额大于余额');
            return
          }

          let filteredRechargeList = this.Recharge;


          if (this.unifiedRechargeAmount <= 0) {
            filteredRechargeList = this.Recharge.filter(item => {
              if (item.balance <= 0) {

                return false;
              }
              return true;
            });
          }

          if (filteredRechargeList.length === 0) {
            this.$message.info('没有符合条件的账号可进行操作');
            return;
          }


          for (const item of filteredRechargeList) {
            try {
              console.log(this.Rechargenumber);
              console.log(this.unifiedRechargeAmount);
              if (this.Rechargenumber<this.unifiedRechargeAmount) {
                this.$message.warning('充值失败，余额不足，充值终止');
                break;
              }
              const res = await this.$axios.post('https://control.zjwec.cn/api/qtt/charge', {
                cookie: item.cookie,
                money: this.unifiedRechargeAmount * 100,
                user: item.id
              });



              if (res.data.data.errorType == 'errorMessage') {
                this.$message.error(`${item.username} 充值失败：${res.data.data.message}`);
              } else {
                this.$message.success(`${item.username} 统一操作成功！`);
                this.Rechargenumber -= this.unifiedRechargeAmount;
              }
            } catch (err) {
              this.$message.error(`${item.username} 操作失败: ${err.message}`);
            }
          }

        }

        this.rechargeDialogVisible = false;
      } catch (error) {
        this.$message.error(`操作异常: ${error.message}`);
      } finally {
        this.recharging = false;
      }
    },
    fzChange(row) {
      this.selectfzzh = row
      this.dialogVisible = true

    },
    addRow() {
      this.zzformData.push({ accountId: '', accountName: '', password: '' });
    },
    // 删除某行
    deleteRow(index) {
      this.zzformData.splice(index, 1);
    },
    // 导入 Excel
    handleExcelImport(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);
        this.zzformData = jsonData.map(item => ({
          accountId: item['被复制账户ID'] || '',
          accountName: item['账号名称'] || '',
          password: item['密码'] || ''
        }));
      };
      reader.readAsBinaryString(file);
      return false; // 阻止 el-upload 自动上传
    },
    // 下载 Excel 模板
    downloadTemplate() {
      const data = [
        { '被复制账户ID': '', '账号名称': '', '密码': '' }
      ];
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '模板');
      XLSX.writeFile(wb, '复制账户模板.xlsx');
    },
    // 确认按钮
    async submit() {
      const successList = [];
      const failList = [];

      const promises = this.zzformData.map(item => {
        const payload = {
          copyid: item.accountId,
          username: item.accountName,
          pwd: item.password,
          token: this.selectfzzh.qttcookie
        };

        return axios.post('https://control.zjwec.cn/api/qtt/fzzh', payload, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          const responseData = res.data;

          if (responseData.status === 'success' && responseData.data && responseData.data.id) {
            // 成功
            successList.push({
              account: item.accountName,
              id: responseData.data.id
            });

            this.$notify({
              title: '提交成功',
              message: `账号 ${item.accountName} 创建成功，ID: ${responseData.data.id}`,
              type: 'success',
              duration: 3000
            });

          } else {
            // 失败（但返回成功结构）
            failList.push({
              account: item.accountName,
              reason: responseData.message || '无ID返回，逻辑失败'
            });

            this.$notify({
              title: '提交失败',
              message: `账号 ${item.accountName} 创建失败，原因：${responseData.message || '无ID返回'}`,
              type: 'error',
              duration: 5000
            });
          }
        }).catch(error => {
          // 异常失败
          failList.push({
            account: item.accountName,
            reason: error.message || '未知错误'
          });

          this.$notify({
            title: '请求异常',
            message: `账号 ${item.accountName} 提交出错：${error.message}`,
            type: 'error',
            duration: 5000
          });
        });
      });

      try {
        await Promise.all(promises); // 所有都执行完再处理结果汇总

        // 成功/失败总结
        this.$message.success(`提交完成，成功 ${successList.length} 条，失败 ${failList.length} 条`);

        // 可选：控制台输出失败详情
        if (failList.length > 0) {
          console.warn('失败详情：', failList);
        }

      } catch (e) {
        console.error('批量提交异常：', e);
        this.$message.error('批量提交出错');
      }

      // 清空数据和关闭弹窗
      this.zzformData = [];
      this.dialogVisible = false;
    },













    statusText(row) {
      if (row.isValid === 1) return '有效';
      if (row.isValid === 0) return '失效';
      return row.checkTime ? '未知' : '未巡检';
    },
    statusTagType(row) {
      if (row.isValid === 1) return 'success';
      if (row.isValid === 0) return 'danger';
      return 'info';
    },
    formatStatusTime(value) {
      if (!value) return '-';
      const date = new Date(value);
      if (isNaN(date.getTime())) return value;
      return date.toLocaleString('zh-CN', { hour12: false });
    },
    wuxiao1() {
      this.outerVisible = false
      this.formdata = {}
      this.$refs.formdata.clearValidate();
    },
    wuxiao2() {
      this.outerVisible2 = false
      this.formdata2 = {}
      this.$refs.formdata2.clearValidate();
    },
    innerVisible() {
      this.$refs.formdata.validate((valid) => {
        if (valid) {
          // this.innerVisible();
          console.log(valid);
          //编辑
          axios.put('https://control.zjwec.cn/api/qtt/update', {
            ...this.formdata,
            userid: this.userId
          }).then(res => {
            this.$notify({
              title: 'success',
              message: '修改成功',
              type: 'success'
            });
            this.getUlist()
            this.outerVisible = false
            this.wuxiao1()
          }).catch(res => {
            this.$notify({
              title: 'error',
              message: '修改失败',
              type: 'error'
            });
            this.wuxiao1()
          })
        } else {
          return
        }

      });

    },
    innerVisible2() {
      this.$refs.formdata2.validate((valid) => {
        if (valid) {
          // this.innerVisible();
          axios.post('https://control.zjwec.cn/api/qtt/create', {
            ...this.formdata2,
            userid: this.userId
          }).then(res => {
            this.$notify({
              title: 'success',
              message: '新增成功',
              type: 'success'
            });
            this.getUlist()
            this.outerVisible = false
            this.wuxiao2()
          }).catch(res => {
            this.$notify({
              title: 'error',
              message: '新增失败',
              type: 'error'
            });
            this.wuxiao1()
          })
        } else {
          return;
        }

      });
    },
    delmethod() {

    },
    interVisible() {
      this.statusnum = 2
      this.outerVisible = true
      this.formdata = {}
    },
    editchang(row) {
      this.statusnum = 1
      this.outerVisible = true
      this.formdata = { ...row }
    },
    delchang(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.get('https://control.zjwec.cn/api/qtt/delete', {
          params: { id: row.id }
        }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getUlist()

        }).catch(res => {
          this.$notify({
            title: 'error',
            message: '修改失败',
            type: 'error'
          });
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    gettheout() {
      this.outerVisible2 = true
      // this.statusnum = 2
    },
    query() {
      // if (!this.verificationCode) {
      this.$message.success("查询成功")
      // }

      this.qttlist()


    },
    qttlist() {
      //     axios.get('https://control.zjwec.cn/api/qtt/list', {
      //     responseType: 'blob',
      //     params: { khname: this.verificationCode }
      //   })
      this.loading = true;
      this.responseResultslist = []
      axios.get('https://control.zjwec.cn/api/qtt/list', {
        params: { khname: this.verificationCode, userid: this.userId }
      }).then(response => {

        this.responseResultslist = response.data
      }).catch(error => {
        console.error('请求失败:', error);
        // ...
      })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(dateStr) {

      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    getUlist() {
      axios.get('https://control.zjwec.cn/api/qtt/list', {
        params: { userid: this.userId }
      }).then(response => {
        this.responseResultslist = response.data
      })
    },


  },

};
</script>

<style scoped>
.select-container {
  margin: 0 15px;
}

/* 这里可以添加一些自定义样式 */
/* .captcha-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin: 20px 0;
  }

  .captcha-wrapper {
    position: relative;
    cursor: pointer;
  }

  .captcha-image {
    width: 120px;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .loading-indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.7);
    color: #333;
    font-size: 12px;
  } */

/* .select-container {
    display: flex;
    flex-wrap: wrap;
    gap: 2px;
    flex: 1;
    min-width: 200px;
  } */



/* .date-picker {
    min-width: 150px;
  }

  .submit-button {
    height: 40px;
    padding: 0 20px;
    background-color: #409eff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;
    white-space: nowrap;
  }

  .submit-button:hover {
    background-color: #368ee0;
  }

  .submit-button:disabled {
    background-color: #a0cfff;
    cursor: not-allowed;
  } */

/* 适配小屏幕 */
/* @media (max-width: 600px) {
    .captcha-container {
      flex-direction: column;
    }

    .select-container {
      width: 100%;
    }

    .custom-select, .date-picker {
      width: 100%;
      min-width: auto;
    }

    .submit-button {
      width: 100%;
    }
    } */
.recharge-dialog {
  margin-top: 15vh !important;
}

.dialog-content {
  padding: 20px;
}

.m-header {
  margin-bottom: 20px;
  text-align: center;
}

.m-header .el-button {
  margin-right: 16px;
}

.m-header .el-button.active {
  background-color: #f5f7fa;
  border-color: #409eff;
  color: #409eff;
}

.separate-recharge {
  margin-top: 20px;
}

.unified-container {
  display: flex;
  gap: 10px;
  /* 表格和表单之间的间距 */
}

.batch-form {
  width: 300px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.batch-header {
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  padding: 8px 12px;
  font-weight: bold;
}

.batch-body {
  padding: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/quttzh.vue